// plugins/google_analytics.js

//
// REGULAR, MAIN-THREAD VERSION
// TODO: NOT TRACKING page_view evenets between routes
//

let skippedFirstRouteChange = false

export default defineNuxtPlugin((nuxtApp) => {
    //onNuxtReady(() => {  // onNuxtReady is called after hydration
    // return
    const config = useAppConfig()
    if (config.RUN_MODE === 'development') return // add Google Analytics only in production mode

    if (process.client) {
        const queryParams = new URLSearchParams(window.location.search)
        if (queryParams.has('noAnalytics')) {
            console.warn("Google Analytics disabled bc 'noAnalytics=true' is set")
            return
        }

        // Add Google Analytics script to the client-side only
        // console.log("Injecting google analytics script")

        const ga_script = document.createElement('script')
        ga_script.type = 'text/javascript'
        ga_script.src = 'https://www.googletagmanager.com/gtag/js?id=G-29B4MB0PER'
        // ga_script.async = true;
        // ga_script.defer = true
        document.head.appendChild(ga_script)

        const ga_script_2 = document.createElement('script')
        ga_script_2.type = 'text/javascript'
        ga_script_2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-29B4MB0PER', { cookie_flags: 'SameSite=None;Secure' });
                `
        document.head.appendChild(ga_script_2)

        nuxtApp.$router.afterEach(() => {
            if (skippedFirstRouteChange) {
                fire_event('page_view')
            } else {
                //console.log('skipping first afterEach call')
                skippedFirstRouteChange = true
            }
        })
    }
})
